import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'register-form-general-endusers',
	templateUrl: './general-endusers.component.html',
	styleUrls: ['./general-endusers.component.scss'],
})
export class GeneralEndusersComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
